import { render, staticRenderFns } from "./TotalStats.vue?vue&type=template&id=4fd16e58&"
import script from "./TotalStats.vue?vue&type=script&lang=ts&"
export * from "./TotalStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports